import React from 'react'
import { UnitMaster } from '../../../../Units/reducer'

export const ChangeUnitDescription: React.FC<{
  selectedRow: UnitMaster | null
  val: UnitMaster | null
}> = ({ selectedRow, val }) => (
  <div>
    Are you sure you want to change{' '}
    <span
      style={{
        fontWeight: 'bold',
      }}
    >
      UNIT {selectedRow?.unitNumber}
    </span>{' '}
    TO{' '}
    <span
      style={{
        color: 'red',
        fontWeight: 'bold',
      }}
    >
      UNIT {val?.unitNumber}
    </span>
    ?
  </div>
)
